import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { LocalStorage } from '../../LocalStorage';

export interface IStatusesState {
  confirmedReceiptsReloading: boolean;
  expensesReloading: boolean;
  documentLoading: boolean;
  documentLoadingError: boolean;
  documentPage: number;
  documentPages: number;
  formUpdating: boolean;
  lastTransactionDateReloading: boolean,
  menuCollapsed: boolean;
  selectedNav: number;
  selectedNavPos: number;
  uploadReceiptForm: boolean;
  uploadedReceiptID: number;
};

const initialState: IStatusesState = {
  confirmedReceiptsReloading: false,
  expensesReloading: false,
  documentLoading: false,
  documentLoadingError: false,
  documentPage: 1,
  documentPages: 1,
  formUpdating: false,
  lastTransactionDateReloading: true,
  menuCollapsed: false,
  selectedNav: LocalStorage.nav,
  selectedNavPos: LocalStorage.navPos,
  uploadReceiptForm: false,
  uploadedReceiptID: -1,
};

export const statusesSlice = createSlice({
  name: 'statuses',
  initialState,
  reducers: {
    updateConfirmedReceiptsState: (state: IStatusesState, action: PayloadAction<boolean>) => {
      state.confirmedReceiptsReloading = action.payload;
    },
    updateDocumentState: (state: IStatusesState, action: PayloadAction<boolean>) => {
      state.documentLoading = action.payload;
      if (action.payload) {
        state.documentLoadingError = false;
      }
    },
    updateDocumentErrorState: (state: IStatusesState, action: PayloadAction<boolean>) => {
      state.documentLoadingError = action.payload;
    },
    updateDocumentPage: (state: IStatusesState, action: PayloadAction<number>) => {
      state.documentPage = action.payload;
    },
    updateDocumentPages: (state: IStatusesState, action: PayloadAction<number>) => {
      state.documentPages = action.payload;
    },
    updateExpensesState: (state: IStatusesState, action: PayloadAction<boolean>) => {
      state.expensesReloading = action.payload;
    },
    updateFormUpdatingState: (state: IStatusesState, action: PayloadAction<boolean>) => {
      state.formUpdating = action.payload;
    },
    updateLastTransactionReloadingState: (state: IStatusesState, action: PayloadAction<boolean>) => {
      state.lastTransactionDateReloading = action.payload;
    },
    setMenuCollapsed: (state: IStatusesState, action: PayloadAction<boolean>) => {
      state.menuCollapsed = action.payload;
    },
    setSelectedNav: (state: IStatusesState, action: PayloadAction<number>) => {
      state.selectedNav = action.payload;
    },
    setSelectedNavPos: (state: IStatusesState, action: PayloadAction<number>) => {
      state.selectedNavPos = action.payload;
    },
    setUploadReceiptForm: (state: IStatusesState, action: PayloadAction<boolean>) => {
      state.uploadReceiptForm = action.payload;
    },
    setUploadedReceiptID: (state: IStatusesState, action: PayloadAction<number>) => {
      state.uploadedReceiptID = action.payload;
    },
  },
});

export const { updateDocumentErrorState, updateDocumentState, updateLastTransactionReloadingState, updateDocumentPage, updateDocumentPages } = statusesSlice.actions;
export const expensesReloadingState = (state: RootState) => state.statuses.expensesReloading;
export const documentLoadingState = (state: RootState) => state.statuses.documentLoading;
export const documentLoadingErrorState = (state: RootState) => state.statuses.documentLoadingError;
export const documentPageState = (state: RootState) => state.statuses.documentPage;
export const documentPagesState = (state: RootState) => state.statuses.documentPages;
export const formUpdatingState = (state: RootState) => state.statuses.formUpdating;
export const lastTransactionDateReloadingState = (state: RootState) => state.statuses.lastTransactionDateReloading;
export const menuCollapsedState = (state: RootState) => state.statuses.menuCollapsed;
export const selectedNavState = (state: RootState) => state.statuses.selectedNav;
export const selectedNavPosState = (state: RootState) => state.statuses.selectedNavPos;
export const uploadReceiptFormState = (state: RootState) => state.statuses.uploadReceiptForm;
export const uploadedReceiptIdState = (state: RootState) => state.statuses.uploadedReceiptID;

export default statusesSlice.reducer;
